import React from 'react';
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";


export default class CustomerName extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		prefix: PropTypes.string,
		onTextUpdate: PropTypes.func.isRequired,
		crmAvailable: PropTypes.bool,
	};

	render() {
		/** @type {Customers_Object} object */
		let object = this.props.object;
		/** @type {Customers_Properties} properties*/
		let properties = this.props.properties;
		let {prefix, onTextUpdate} = this.props;
		prefix = prefix || '';
		//CRM: force first/last name required when the account has the CRM module (server stays authoritative)
		const forceReq = !!this.props.crmAvailable;


		return <div>
			<div className={'row'}>
				<div className={'col-8'}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"First Name"}
							property={forceReq ? {...(properties[prefix + 'name_first'] || {}), required: true} : properties[prefix + 'name_first']}
							value={object[prefix + 'name_first']}
							error={object[prefix + 'name_first_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
				<div className={'col-4'}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Middle"}
							property={properties[prefix + 'name_middle']}
							value={object[prefix + 'name_middle']}
							error={object[prefix + 'name_middle_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
			</div>
			<div className={'row'}>
				<div className={"col-8"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Last Name"}
							property={forceReq ? {...(properties[prefix + 'name_last'] || {}), required: true} : properties[prefix + 'name_last']}
							value={object[prefix + 'name_last']}
							error={object[prefix + 'name_last_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
				<div className={"col-4"}>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Suffix"}
							property={properties[prefix + 'name_suffix']}
							value={object[prefix + 'name_suffix']}
							error={object[prefix + 'name_suffix_error']}
							update={onTextUpdate}
							disabled={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
						/>
					</div>
				</div>
			</div>

		</div>

	}
}

